import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { PER_NIGHT, FROM_PRICE_PER_PERIOD } from "../../../utils/default-strings";
import { getCardPlaceholderMarkup } from "../../../utils/get-card-placeholder-markup";
import { getPricePerPeriodMarkup } from "../../../utils/get-price-per-period-markup";
import { Rating } from "../../elements/Rating";
import { ResponsiveImage } from "../../media/ResponsiveImage";
import { Subheading } from "../../typography/Subheading";
import { Heading } from "../../typography/Heading";
import { getPropertyDescription } from "./utils/getPropertyDescription";
export var Component = function Component(_ref) {
  var bedroomsNumber = _ref.bedroomsNumber,
      guestsNumber = _ref.guestsNumber,
      imageSizes = _ref.imageSizes,
      imageSrcSet = _ref.imageSrcSet,
      imageUrl = _ref.imageUrl,
      isShowingPlaceholder = _ref.isShowingPlaceholder,
      locationName = _ref.locationName,
      periodText = _ref.periodText,
      pricePerPeriodPrefix = _ref.pricePerPeriodPrefix,
      pricePerPeriod = _ref.pricePerPeriod,
      placeholderImageUrl = _ref.placeholderImageUrl,
      propertyName = _ref.propertyName,
      propertyType = _ref.propertyType,
      propertyUrl = _ref.propertyUrl,
      ratingNumber = _ref.ratingNumber,
      propertyUrlTarget = _ref.propertyUrlTarget;
  return React.createElement(Card, {
    className: "has-featured",
    href: propertyUrl,
    target: propertyUrlTarget
  }, isShowingPlaceholder ? getCardPlaceholderMarkup() : React.createElement(Fragment, null, React.createElement(ResponsiveImage, {
    imageUrl: imageUrl,
    isFluid: true,
    placeholderImageUrl: placeholderImageUrl,
    sizes: imageSizes,
    srcSet: imageSrcSet
  }), React.createElement(Card.Content, null, React.createElement(Card.Meta, null, React.createElement(Subheading, null, propertyType)), React.createElement(Card.Header, null, React.createElement(Heading, null, propertyName)), React.createElement(Card.Description, null, locationName), React.createElement(Card.Description, null, getPropertyDescription(guestsNumber, bedroomsNumber)), React.createElement(Card.Description, null, !!ratingNumber && React.createElement(Rating, {
    iconSize: "tiny",
    ratingNumber: ratingNumber
  })), React.createElement(Card.Description, null, getPricePerPeriodMarkup(pricePerPeriod, pricePerPeriodPrefix, periodText)))));
};
Component.displayName = 'FeaturedProperty';
Component.defaultProps = {
  bedroomsNumber: null,
  imageSizes: undefined,
  imageSrcSet: undefined,
  isShowingPlaceholder: false,
  periodText: PER_NIGHT,
  pricePerPeriodPrefix: FROM_PRICE_PER_PERIOD,
  placeholderImageUrl: undefined,
  propertyUrlTarget: '_self',
  ratingNumber: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  bedroomsNumber: PropTypes.number,
  guestsNumber: PropTypes.number.isRequired,
  imageSizes: PropTypes.string,
  imageSrcSet: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  isShowingPlaceholder: PropTypes.bool,
  locationName: PropTypes.string.isRequired,
  periodText: PropTypes.string,
  placeholderImageUrl: PropTypes.string,
  pricePerPeriod: PropTypes.string.isRequired,
  pricePerPeriodPrefix: PropTypes.string,
  propertyName: PropTypes.string.isRequired,
  propertyType: PropTypes.string.isRequired,
  propertyUrl: PropTypes.string.isRequired,
  propertyUrlTarget: PropTypes.string,
  ratingNumber: PropTypes.number
} : {};